import FeedbackButtons from './feedback-buttons';

export default FeedbackButtons;
